module.exports = __webpack_public_path__ + "img/storeReview-mobile.1e447755.png";